import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class BookingsiteService {
  quickLoginUrl;

  constructor(private http: HttpClient) {}

  setQuickLoginUrl(url) {
    this.quickLoginUrl = url;
  }

  generateBsUrl(url) {
    return `${this.quickLoginUrl}&redirect_url=${encodeURIComponent(url)}`;
  }

  /**
   * 账号列表
   */
  fetchAccountList(params) {
    return this.http.get("/api/bs/account/list", { params });
  }

  /**
   * 创建账号
   */
  requestCreateAccount(params) {
    return this.http.post("/api/bs/account/create", params);
  }

  /**
   * 删除账号
   */
  requestDeleteAccount(params) {
    return this.http.post("/api/thirdparty/delete", params);
  }

  /**
   * 账号详情
   */
  fetchAccountDetail(params) {
    return this.http.get("/api/bs/account/detail", { params });
  }

  /**
   * 账号下房间列表
   */
  fetchListingList(params) {
    return this.http.get("/api/bs/listings/list", { params });
  }

  /**
   * 同步房源
   */
  requestSyncHouse(params) {
    return this.http.get("/api/thirdparty/syncer_house", { params });
  }

  /**
   * 房源关联
   */
  requestLinkListing(params) {
    return this.http.post("/api/listing_linking/link", params);
  }

  requestUpdateListStaus(params) {
    return this.http.post("/api/bs/listings/set_listed", params);
  }

  // requestBindHouse(params) {
  //   return this.http.post('/api/house_relation/join_hostex_house', params);
  // }

  // requestBindType(params) {
  //   return this.http.post('/api/house_type/join', params);
  // }
}
